export default "__VITE_ASSET__DEveB3c0__"